var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('MentionBox',{attrs:{"items":_vm.items},on:{"mentionSelect":_vm.handleMentionClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }